<template>
  <v-container class="mt-2 pr-2">

    <v-row>
      <v-col cols="12">
        <v-card width="100%" height="100%" class="shadowCard">
          <v-card-title primary-title >
            Rutas

            <v-spacer></v-spacer>
            
            <!-- NUEVO -->
            <v-btn align="right" 
              color="primary" dark small 
              class="mr-2" 
              @click="dialog = true"
              tile
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn  class="orange" small tile dark @click="initialize" ><v-icon>mdi-refresh</v-icon> </v-btn>

          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="rutas"
            dense
          >
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="350px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-text-field 
          	filled
          	dense
          	v-model="editedItem.nomruta" 
          	label="Nombre de la ruta"
          ></v-text-field>
          <v-text-field 
          	filled
          	hide-details
          	dense
          	v-model="editedItem.ruta" 
          	label="ruta"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            @click="close"
            tile
            dense
          >
          	<v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            dark
            @click="save"
            tile
          >
          	<v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>

<script>

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      headers: [
        { text: 'Nombre de la ventana', align: 'start', value: 'nomruta'},
        { text: 'Ruta', value: 'ruta' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      rutas: [],
      editedIndex: -1,
      editedItem: {
        idruta:0,
        name: '',
        calories: 0,
      },
      defaultItem: {
        idruta:0,
        name: '',
        calories: 0,
      },

      // Alerta
      snackbar:false,
      color:'success',
      text:''
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva ruta' : 'Editar ruta'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // Inicializamos las rutas en vacio
        this.rutas = []
        this.cargar = true
        // Obtenemos todas las rutas
        this.$http.get('rutas.all').then(response=>{
          this.rutas = response.body
          this.cargar = false
        }).catch(error=>{this.cargar = false})
      },

      editItem (item) {
        this.editedIndex = this.rutas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.cargar = true
        if (this.editedIndex > -1) {
          this.$http.put('ruta.update/' + this.editedItem.idruta ,this.editedItem).then(response=>{
            this.validarSuccess('Ruta actualizada correctamente')
        		this.close()
            this.initialize()
          }).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
        } else {
          this.$http.post('ruta.add',this.editedItem).then(response=>{
            this.validarSuccess('Ruta agregada correctamente')
        		this.close()
            this.initialize()
          }).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
        }
      },
    },
  }
</script>